<template>
  <div class="wrap-statistic">
    <head-view :option="title" :subtitleOpt="subtitleOpt"></head-view>
    <!-- <b-loading :is-full-page="false" :active.sync="$store.state.isLoader" :can-cancel="false"></b-loading> -->
    <div class="statistics-content">
      <div class="content__filters">
        <div class="filter__buildings">
          <!-- <select name="buildings" v-model="building" id="" placeholder="Elija Edificio" @input="changeDate">
            <option value="">Todos los edificios</option>
            <option :value="edi._id" v-for="edi of buildingsStatList" :key="edi._id">{{edi.name}}</option>
          </select> -->
          <b-select v-if="$store.state.namespace === 'experience'" name="categories" placeholder="Elija Categoría" class="input-select-custom" v-model="category" @input="changeDate">
            <option :value="undefined">Categorías</option>
            <option :value="cat.value" v-for="cat of catList" :key="`filter-cat-${cat.value}`">
              {{cat.labe}}
            </option>
          </b-select>
          <b-select name="buildings" placeholder="Elija Edificio" class="input-select-custom" v-model="building" @input="changeDate">
            <option value="">Todos-Edificios</option>
            <option :value="edi._id" v-for="edi of buildingsStatList" :key="edi.id">
              {{edi.name}}
            </option>
          </b-select>
        </div>
        <template>
          <div class="filter__date">
            <div class="datepicker-trigger date">
              <input
                class="input-date"
                type="text"
                id="datepicker-trigger"
                placeholder="Seleccione las fechas"
                :value="formatDates(dateOne, dateTwo)">

                <AirbnbStyleDatepicker
                  :trigger-element-id="'datepicker-trigger'"
                  :mode="'range'"
                  :fullscreen-mobile="true"
                  :date-one="dateOne"
                  :date-two="dateTwo"
                  @date-one-selected="val => { dateOne = val }"
                  @date-two-selected="val => { dateTwo = val }"
                  @apply="changeDate"/>
              </div>
          </div>
        </template>
      </div>
      <h4 class="compare-title">Punto de control</h4>
      <!-- <div class="content__chart" v-if="existCheckpointChart">
        <div id="myChart" ref="apexChart"></div>
      </div> -->

      <div class="content__chart" v-if="existBuildingsStats">
        <div id="apexBuildings" ref="bChart" class="charts"></div>
      </div>
      <b-loading v-else :is-full-page="false" :active.sync="$store.state.isLoader" :can-cancel="false"></b-loading>
    </div>
    <div class="statistics-content--2">
      
      <h4 class="compare-title">Comparar tareas por edificios en un determinado punto de control</h4>
      <div class="content__table">
        <div class="wrapper-select wrapper-select--footer">
          <div class="table-section">
						<b-table
						class="table-history"
            :data="buildingsStatList ? buildingsStatList : []"
            >
							<template slot-scope="props">
									<b-table-column field="well" label="Elegir para comparar">
											<b-checkbox
                              type="is-info"
                              size="is-medium"
                              :native-value="props.row"
                              v-model="props.row.checked"
                              aria-checked="checked"
                              @input="checkuncheck(props.row)">
                      </b-checkbox>
									</b-table-column>
									<b-table-column field="name" label="Edificio" width="300" >
											{{ props.row.name }}
									</b-table-column>
                  <b-table-column field="bad" label="Histórico" numeric>
											<router-link class="button-edit" :to="{name:'statisticCheckpointBuildingsHistoric',params:{
                        id:$route.params.id,
                        fk:props.row._id
                      }}">
                      ver detalles
                      </router-link>
									
                  </b-table-column>
							</template>

							<template slot="empty">
									<section class="section">
											<div class="content has-text-grey has-text-centered">
													<p>
															<b-icon
																	icon="emoticon-sad"
																	size="is-large">
															</b-icon>
													</p>
													<p>No hay datos en el rango de fechas seleccionadas.</p>
											</div>
									</section>
							</template>
        		</b-table>
					</div>
				</div>
      </div>
      <!-- <div class="content__chart">
        <div id="myChart" ref="apexChart2"></div>
      </div> -->
    </div>
  </div>
</template>

<script>
import headView from "../Componentes/headView";
import { mapState, mapGetters } from "vuex";
import ApexCharts from "apexcharts";
import format from "date-fns/format";
export default {
  name: "statisticCheckpointBuildings",
  components: {
    headView
  },
  data() {
    return {
      title: {
        headText: "Estadísticas: Puntos de Control",
        subtitle: ""
      },
      subtitleOpt: false,
      buildings: [],
      myChart: {},
      myChart2: {},
      chartsType: ["column", "area", "line"],
      dateSelect: "",
      isLoading: true,
      dateFormat: "D MMM",
      building: "",
      category: undefined,
      dateOne: "",
      dateTwo: "",
      catList: [{
        label: "Area común",
        value: "common-area"
      },{
        label: "Cliente",
        value: "client"
      }],
    };
  },
  computed: {
    ...mapState([
      "currentCPStat",
      "currentCheckpointChart",
      "companyId",
      "currentCheckpointChartEdi",
      "buildingsChart",
      "buildingsStatList",
      "buildingsChartPayload"
    ]),
    ...mapGetters([
      "getCPById",
      "edificios",
      "buildingsByCP",
      "reportByCP",
      "reportByBuild",
      "getColorChildren"
    ]),
    existBuildingsStats: function() {
      // this.$store.commit("activeLoader")
      if (this.buildingsChart) {
        this.$nextTick(() => {
          this.bChart = new ApexCharts(this.$refs.bChart, this.buildingsChart);
          this.bChart.render();
          // this.$store.commit("deactiveLoader")
        });
        return true;
      } else {
        return false;
      }
    },
    existCheckpointChart: function() {
      if (this.currentCheckpointChart) {
        this.$nextTick(() => {});
        return true;
      }
      return false;
    },
    existCheckpointChartEdi: function() {
      if (this.buildings) {
        let obj = {
          edArr: this.buildings,
          datos: this.reportByBuild,
          chartsType: ["column"],
          rep: this.reportByBuild
        };
        if (this.currentCheckpointChartEdi) {
          return true;
        }
      }

      return false;
    },
    isLoadingComp() {
      if (this.buildingsStatList.length != 0) {
        
        return false;
      }
      return true;
    }
  },
  beforeCreate() {
    this.$store.commit("setColorChildren", "statistics");
  },
  beforeDestroy() {
    this.$store.commit("activeLoader")
    this.$store.commit("resetColorChildren", "statistics");
  },
  created() {
    var sDate = new Date();
    this.$store.dispatch("GETSTATBUILDINGS", {
      checkpoint: this.$route.params.id,
      startDate: new Date(sDate.setHours(0, 0, 0, 0)).toISOString(),
      endDate: new Date().toISOString(),
      category: this.category
    });
    // console.log(new Date(sDate.setHours(0,0,0,0)).toISOString());

    // this.$store.dispatch("GETSTATBUILDINGS", {
    //   checkpoint: this.$route.params.id,
    //   // startDate: new Date().now()
    // });
  },
  methods: {
    changeDate: function() {
      this.$store.commit("activeLoader")
      var sDate = new Date();
      this.$nextTick(() => {
        this.$store.dispatch("GETSTATBUILDINGS", {
          checkpoint: this.$route.params.id,
          startDate:
            this.dateOne == ""
              ? new Date(sDate.setHours(0, 0, 0, 0)).toISOString()
              : new Date(
                  new Date(this.dateOne.replace("-", ".")).setHours(0, 0, 0, 0)
                ).toISOString(),
          endDate:
            this.dateTwo == ""
              ? new Date().toISOString()
              : new Date(
                  new Date(this.dateTwo.replace("-", ".")).setHours(23, 0, 0, 0)
                ).toISOString(),
          building: this.building,
          category: this.category
        });
      });
      //usa metodo post del api con campos startDate y endDate
    },
    checkuncheck: function(row) {
      this.$store.commit("activeLoader")
      this.$store.commit("drawBuildingsStatComp", this.buildingsStatList);
      this.$nextTick(() => {
        this.bChart = new ApexCharts(this.$refs.bChart, this.buildingsChart);
        this.bChart.render();
        this.$store.commit("deactiveLoader")
      });
    },
    formatDates(dateOne, dateTwo) {
      let formattedDates = "";
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat);
      }
      if (dateTwo) {
        formattedDates += " - " + format(dateTwo, this.dateFormat);
      }
      return formattedDates;
    }
  },
  watch: {
    "buildingsStatList.checked": function(n) {}
  }
};
</script>
<style lang="scss">
.asd__day {
  padding: 0.3em !important;
}
</style>
<style lang="scss" scoped>
.wrap-statistic {
  height: 100%;
}
.statistics-content {
  margin-top: 4em;
  padding: 2em;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  &--2 {
    margin-top: 1em;
    padding: 1em 2em;
  }
  .content__filters {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: 0 5rem;
    select {
      width: 200px;
      padding: 0.5rem 1rem;
      border: none;
      border-bottom: thin solid #cacaca;
      background-color: inherit;
      font-size: 1rem;
      margin: 0 2rem;
      color: inherit;
      &:active,
      &:focus {
        outline: none;
      }
    }

    .filter__buildings{
      min-width: 220px !important;
    }

    .filter__date{
      margin-left: 2rem;
      margin-bottom: 1rem;
      display: flex;
      align-items:center;
      // font-size: 1.2rem;
      // .date{
      //   // height: 100%;
      //   top: 50%;
      //   transform: translateY(-50%);
      //   .input-date{
      //     height: 100%;
      //   }
      // }
    }
  }
}
.charts {
  margin: auto;
}
.compare-title {
  text-align: left;
  margin-bottom: 10px;
}
.content__filters {
  display: flex;
  .filters__item {
    margin: 10px;
  }
}
#myChart {
  display: flex;
  justify-content: center;
}
</style>

<style>
.button-edit {
  border: thin solid #e6e4e6;
  padding: 1rem;
  color: #000000;
  font-weight: bold;
  margin: 25px;
}
.input-date {
  padding: 0.5rem 1rem;
  font-size: 0.8rem;
  border: thin solid #00a699;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/statisticCheckpointBuildings.vue